jQuery(function($) {
	// Extend the inline edit post function
	const wp_inline_edit = inlineEditPost.edit;
	inlineEditPost.edit = function(post_id) {
		wp_inline_edit.apply(this, arguments);

		var postId = 0;
		if (typeof (post_id) === 'object') {
			postId = parseInt(this.getId(post_id));
		}

		if (postId > 0) {
			// Get the contribution value
			const $editRow = $('#edit-' + postId);
			const $postRow = $('#post-' + postId);
			const contribution = $postRow.find('.column-contribution').text();

			// Set the contribution value in the Quick Edit field
			$editRow.find('select[name="contribution"]').val(contribution);
		}
	};
});
